import {
  CreateShoppingSessionRequest,
  EntityReference,
  ShoppingSession,
  ShoppingSessionReference,
} from '../../core/api/api.entities';
import { ShoppingSessionFormControls } from '../form-controls/shopping-session.form-controls';
import { ShoppingSessionFormOptions } from '../form-options/shopping-session.form-options';
import { BaseForm } from './base.form';

export class ShoppingSessionForm extends BaseForm<ShoppingSessionFormControls> {
  formGroup = this.createFormGroup(ShoppingSessionFormControls);
  override options = new ShoppingSessionFormOptions();

  get data(): CreateShoppingSessionRequest {
    if (!this.formGroup.valid) {
      throw new Error('Form is invalid');
    }

    const controls = this.controls;

    return {
      bonus: controls.bonus.value,
      date: controls.date.value.toISOString(),
      excluded: controls.excluded.value,
      storeId: controls.store.value?.id,
      total: controls.total.value,
    };
  }

  set data(shoppingSession: ShoppingSession) {
    this.formGroup.patchValue({
      bonus: shoppingSession.bonus,
      date: new Date(shoppingSession.date),
      excluded: shoppingSession.excluded,
      store: this.options.stores.find(s => s.id === shoppingSession.storeId),
      total: shoppingSession.total,
    });

    this.resetOriginalData();
  }

  get date(): Date {
    return this.controls.date.value;
  }

  get existingShoppingSession(): ShoppingSessionReference | null {
    return this.controls.existingShoppingSession.value;
  }

  get store(): EntityReference | null {
    if (this.useExisting) {
      return { id: this.existingShoppingSession!.store!.id!, name: this.existingShoppingSession?.store?.name || '' };
    } else return this.controls.store.value || null;
  }

  get useExisting(): boolean {
    return this.controls.existingShoppingSession.value !== null;
  }
}
